import { SelectTimezoneComponent } from './select-timezone.component';

export default angular
  .module('sfMobile.components.select-timezone', [])
  .component('sfSelectTimezone', SelectTimezoneComponent).name;
